import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
// import PropertyBtn from "../PropertyBtn/PropertyBtn"
import { capitalize } from "lodash"

import BathIcon from "@components/icons/BathIcon"
import BedIcon from "@components/icons/BedIcon"
import ReceptionIcon from "@components/icons/ReceptionIcon"
import useTeams from "@hooks/dataHooks/useTeams"
import useOffice from "@hooks/dataHooks/useOffice"

import { GetPrice } from "@common/utils/property_utils"
import { getPropertyURL } from "@lib/propertyUtils"

import NoImg from "@images/noImage.png"
// import GGFXTransform from "@common/stb-jamstack-ggfxclient/module/components/ggfx-transform"
import NegoDetails from "../SalesCard/NegoDetails"

const PropertyCard = ({ item }) => {
  const { teams } = useTeams()
  const { offices } = useOffice()
  const [negoDet, setNegoDet] = useState([])
  const [officeDet, setOfficeDet] = useState([])

  let imgSrc = NoImg

  if (item?.images1?.length > 0 && item.images1[0]["640x"]) {
    imgSrc = item.images1[0]["640x"]
  }

  if (item?.images?.length > 0) {
    if(item.images[0].url){
      imgSrc = item.images[0].url
    }else if(item.images[0].srcUrl){
      imgSrc = item.images[0].srcUrl
    } 
  }

  const thumbImg = item.images2

  let propDesc = item.description
  if (item.description?.data?.description) {
    propDesc = item.description?.data?.description
  }

  const propertyUrl = getPropertyURL(item)

  let flag = ""
  let clsName = ""
  if (item.status === "For Sale" || item.status === "To Let") {
    flag = ""
  } else if (item.status === "Sold" || item.status === "Let") {
    flag = item.status
    clsName = "redclr"
  } else if (item.status === "Under Offer") {
    flag = item.status
  } else {
    flag = item.status
  }

  if (
    item.status !== "Sold" &&
    item.status !== "Let" &&
    item.status !== "Under Offer"
  ) {
    if (item?.is_fineAndCountry === true) {
      flag = "Fine & Country"
      clsName = "fnclr"
    }
  }

  useEffect(() => {
    if (item.negotiator_details) {
      setNegoDet(
        teams.filter((team) => team.email === item.negotiator_details.email),
      )

      if (item?.office_crm_id) {
        setOfficeDet(
          offices.filter(
            (office) =>
              office?.branch_crm_id &&
              office?.branch_crm_id.indexOf(item?.office_crm_id) > -1,
          ),
        )
      }
    }
  }, [item])

  const propTitle = item?.title
    ? item.title.replace("publichouse", "Public house")
    : ""

  // console.log("officeDet ==>", officeDet, item?.negotiator_details?.office_id)

  return (
    <div
      className={`sales-wrap ${item.department} ${
        item.is_featured ? "featured" : ""
      }`}
    >
      {/* ==== Featured Listing === */}
      {item.is_featured && (
        <div className="featured-text">Featured Listing</div>
      )}

      <div className="sales-img-wrap">
        <Link to={propertyUrl}>
          <div className="sales-img img-zoom sss">
            {imgSrc !== "undefined" ? (
              <img src={imgSrc} alt={item.display_address} />
            ) : (
              <img src={imgSrc} alt={item.display_address} />
            )}
            {/* <GGFXTransform
              mediaUrl={imgSrc}
              altText={item.display_address}
              renderer="srcSet"
              transformConfigName="property.images.0.search_results"
              preResult={item.images1}
              id={item.objectID || item.strapi_id}
            /> */}

            {flag && <span className={`top-text ${clsName}`}>{flag} </span>}
          </div>
        </Link>

        {/* ==== Featured Listing === */}
        {item?.images1?.length > 0 &&
          item.images1[0]["640x"] &&
          item.is_featured &&
          thumbImg?.length > 0 && (
            <div className="sm-sales-img-wrap">
              {thumbImg.map((img) => {
                return (
                  <Link to={propertyUrl} key="">
                    <img src={img["200x"]} alt={item.display_address} />
                  </Link>
                )
              })}
            </div>
          )}
      </div>

      <div className="slide-content">
        <div className="price-text">{item.price_qualifier}</div>
        <div className="content">
          <Link to={propertyUrl}>
            <span className="highlight-text">{GetPrice(item.price)}</span>
            <span className="sm-text ">{item.display_address}</span>
            <span className="property-title">{capitalize(propTitle)}</span>
          </Link>
        </div>

        <div className="icon-wrapper">
          {parseInt(item.bedroom, 10) > 0 && (
            <div className="icon-wrap">
              <BedIcon />
              <span className="count">{item.bedroom}</span>
            </div>
          )}

          {parseInt(item.bathroom, 10) > 0 && (
            <div className="icon-wrap">
              <BathIcon />
              <span className="count">{item.bathroom}</span>
            </div>
          )}

          {parseInt(item.reception, 10) > 0 && (
            <div className="icon-wrap">
              <ReceptionIcon />
              <span className="count">{item.reception}</span>
            </div>
          )}
        </div>

        <p
          className="property-content"
          dangerouslySetInnerHTML={{ __html: propDesc }}
        />

        {item.negotiator_details?.id && item.negotiator_details?.name && (
          <NegoDetails
            negoDetails={
              negoDet.length > 0 ? negoDet[0] : item.negotiator_details
            }
            propertyDetails={{
              propertyUrl: process.env.GATSBY_SITE_URL + propertyUrl,
              propertyAddress: item.display_address,
              propertyId: item.crm_id,
              searchType: item.search_type,
            }}
            officeDetails={officeDet.length > 0 ? officeDet[0] : ""}
          />
        )}
      </div>
    </div>
  )
}
export default PropertyCard
